import React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@components/Avatar';
import Skeleton from '@components/Skeleton';
import { useAuthorizationContext } from '@src/context/AuthorizationContext';

const UserProfileSection = () => {
  const employeeDetail = useAuthorizationContext();
  const { t } = useTranslation();

  return (
    <div data-test-id="user-profile-section" className="flex items-center">
      <div className="w-full flex items-center">
        <Avatar size={5} name={employeeDetail?.emp_name} />
        <div className="m-3 p-3">
          <p className="text-xs text-[#5A5D74]" data-testid="logged-in-label">
            {t('header.logged_in_as')}:
          </p>
          {employeeDetail.isLoading ? (
            <Skeleton className="h-6 w-32" />
          ) : (
            <h3 className="text-base font-medium" data-testid="user-name">
              {employeeDetail?.emp_name}
            </h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfileSection;
